import { useState } from "react";
import "./BasemapManager.css";
import { useAnalyticsHandler } from "hooks/useAnalytics";
import { useMobileContext } from "contexts/MobileContext";

const base_url = "mapbox://styles/mapbox/";

export enum BasemapStyle {
  Satellite = "satellite",
  Light = "light",
  Dark = "dark",
}

export const BasemapMap: Record<BasemapStyle, string> = {
  [BasemapStyle.Satellite]: base_url + "satellite-v9",
  [BasemapStyle.Light]: "mapbox://styles/mapbox/light-v11",
  [BasemapStyle.Dark]: "mapbox://styles/mapbox/dark-v11",
};

const CircleSelector = ({
  selectedTheme,
  thisTheme,
  setTheme,
  onCollapse,
}: {
  selectedTheme: string;
  thisTheme: BasemapStyle;
  setTheme: (style: string) => void;
  onCollapse?: () => void;
}) => {
  const selected = thisTheme === selectedTheme;
  const analyticsHandler = useAnalyticsHandler("Basemap Selected");
  const { isTouch } = useMobileContext();

  return (
    <div
      className="circle-selector-container"
      onClick={() => {
        if (isTouch && selected) {
          if (onCollapse) {
            onCollapse();
          }
        } else {
          setTheme(thisTheme);
          analyticsHandler({
            basemap: thisTheme,
          });
        }
      }}
    >
      <p
        className={`font-sans font-bold uppercase circle-selector-text ${
          selectedTheme === BasemapStyle.Light ? "text-open" : "text-white"
        }`}
      >
        {thisTheme}
      </p>
      <div
        className={`circle-selector ${thisTheme} ${selected ? "selected" : ""}`}
      />
    </div>
  );
};

export const BasemapManager = ({
  theme,
  setTheme,
}: {
  theme: string;
  setTheme: (style: string) => void;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const { isTouch } = useMobileContext();

  const handleCollapse = () => {
    setIsOpen(false);
  };

  const handleContainerClick = () => {
    if (isTouch && !isOpen) {
      setIsOpen(true);
    }
  };

  return (
    <div
      className={
        "basemap-manager-container" +
        (theme.includes("light") ? " light" : "") +
        (isTouch ? " mobile" : "")
      }
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
      onClick={handleContainerClick}
    >
      <div className="basemap-manager-inner-container">
        <div className={"circle-selector-outer-container"}>
          {[BasemapStyle.Satellite, BasemapStyle.Light, BasemapStyle.Dark].map(
            (t) => {
              if (isOpen || t === theme) {
                return (
                  <CircleSelector
                    key={t}
                    selectedTheme={theme}
                    setTheme={setTheme}
                    thisTheme={t}
                    onCollapse={handleCollapse}
                  />
                );
              } else {
                return null;
              }
            },
          )}
        </div>
      </div>
    </div>
  );
};
